const updateUser = (state, action) => {
  if(state===undefined || action?.type==='RESET'){
    return {
      user: undefined,
      userName: undefined,
      isLoggedIn: undefined,
      settings: undefined,
      rights:undefined,
      rolename:undefined,
      role:undefined,
    }
  }
  const { user:data } = state;

  switch(action.type){
    case 'SET_USER_USER_DATA':
      return {...data, user: action.payload};
    case 'SET_USER_USER_NAME':
      return {...data, userName: action.payload};
    case 'SET_USER_LOGIN_STATUS':
      return {...data, isLoggedIn: action.payload};
    case 'SET_USER_SETTINGS':
      return {...data, settings: action.payload};
    case 'SET_USER_RIGHTS':
      return {...data, rights: action.payload};
    case 'SET_USER_ROLENAME':
      return {...data, rolename: action.payload};
    case 'SET_USER_ROLE':
      return {...data, role: action.payload};

    default:
      return data;
  }
}

export default updateUser;
